import FormStep from 'components/shared/Form/FormStep';
import Section from 'components/shared/Section';
import { useFetchDealTypes, useFetchStages } from '../hooks';
import { useFetchAutocompleteDropdowns } from '../useFetchAutocompleteDropdowns';
import { sections } from './data';

const Step1 = () => {
  const { businesses, clients, owners } = useFetchAutocompleteDropdowns();
  const map = {
    client: clients,
    business: businesses,
    owner: owners,
  };
  const { dealTypes } = useFetchDealTypes();
  const { stages } = useFetchStages();

  return (
    <FormStep>
      {sections.map((section) => {
        const { title, Component, fields } = section;

        return (
          <Section title={title} key={title}>
            <Component
              autocompleteMap={map}
              fields={fields ?? []}
              dropdowns={{
                dealType: dealTypes,
                stageName: stages,
              }}
            />
          </Section>
        );
      })}
    </FormStep>
  );
};

export default Step1;
